// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Counter_wrapper__u_1Ej"};